import { AppBar, Toolbar, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from '../../../assets/img/logoEBT.png';

// ICONOS
import ContactMailIcon from '@mui/icons-material/ContactMail';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
// import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
// import SettingsIcon from '@mui/icons-material/Settings';
import ReportIcon from '@mui/icons-material/Report';
import RemoveRoadIcon from '@mui/icons-material/RemoveRoad';
import MiBotonLogout from '../../btnLogOut/btnLogOut';


const MainNavBar = () => {

    return (

        <AppBar position="static">
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>

                <Box>

                    <img src={Logo} alt="logo" style={{ width: 111 }} />

                </Box>

                <Box sx={{ display: 'flex', gap: 2 }} >

                    <Button 
                        color="inherit" 
                        component={Link}
                        startIcon={<DashboardIcon />}
                        to="/"
                    >
                        Inicio
                    </Button>

                    {/* <Button 
                        color="inherit" 
                        component={Link}
                        startIcon={<RemoveRoadIcon />}
                        to="/log_incidents"
                    >
                        Incidents
                    </Button> */}

                    <Button 
                        color="inherit" 
                        component={Link} 
                        startIcon={<ReportIcon />}
                        to="/hos"
                    >
                        HOS
                    </Button>

                    <Button 
                        color="inherit" 
                        component={Link} 
                        startIcon={<CarCrashIcon />}
                        to="/unidades_detenidas"
                    >
                        Stoppage
                    </Button>

                    <Button 
                        color="inherit" 
                        component={Link} 
                        startIcon={<AltRouteIcon />}
                        to="/rutas"
                    >
                        Rutas
                    </Button>

                    {/* <Button 
                        color="inherit" 
                        component={Link} 
                        startIcon={<AccessTimeFilledIcon />}
                        to="/idle_events"
                    >
                        Iddle
                    </Button>

                    <Button 
                        color="inherit" 
                        component={Link} 
                        startIcon={<SettingsIcon />}
                        to="/idle_user_config"
                    >
                        Iddle Config
                    </Button> */}

                    <Button 
                        color="inherit" 
                        component={Link} 
                        startIcon={<ContactMailIcon />}
                        to="/config_correos"
                    >
                        Correos
                    </Button>

                    <Button 
                        color="inherit" 
                        component={Link} 
                        startIcon={<ReportProblemIcon />}
                        to="/catalogo_incidencias"
                    >
                        Incidencias
                    </Button>

                    <MiBotonLogout />

                </Box>
                
            </Toolbar>
            
        </AppBar>

    )

}

export default MainNavBar